import axios from "axios"
import { navigate } from "gatsby"
import { configureStore } from "../store"
import { setLoading, setServerErrorPopup } from "../actions/ConfigAction"
import { API_URL, API_URL_WEB, TOKEN_ID } from "config"
import { debug } from "utils/util"

const apiFunction = (method) => {
  return async (url, { body = {}, header = {}, token = true, options = {}, loading = false } = {}) => {
    if (loading) {
      configureStore.dispatch(setLoading(true))
    }
    try {
      let headers = {
        Accept: "application/json",
        ...header,
      }
      if (token) {
        headers.Authorization = `Bearer ${localStorage.getItem(TOKEN_ID)}`
      }
      const result = await axios({
        method: method,
        url: API_URL + url,
        data: body,
        headers,
        responseType: options.responseType,
      })
      debug(result)
      return result
    } catch (err) {
      if (err.response) {
        debug(err.response)
        if (err.response.status === 400) {
          configureStore.dispatch(setServerErrorPopup({ open: true, text: err.response.data.message }))
          return err.response
        } else if (err.response.status === 401) {
          localStorage.removeItem(TOKEN_ID)
          navigate("/app/login")
          return err.response
        } else if (err.response.status === 403) {
          localStorage.removeItem(TOKEN_ID)
          navigate("/app/login")
          return err.response
        } else if (err.response.status === 412) {
          configureStore.dispatch(setServerErrorPopup({ open: true, text: err.response.data.message }))
          navigate("/app/login")
          localStorage.removeItem(TOKEN_ID)
          return err.response
        } else if (err.response.status === 500) {
          configureStore.dispatch(setServerErrorPopup({ open: true, text: err.response.data.message }))
          return err.response
        }
      }
    } finally {
      if (loading) {
        configureStore.dispatch(setLoading(false))
      }
    }
  }
}

const apiFunction_WEB = (method) => {
  return async (url, { body = {}, header = {}, token = true, options = {}, loading = false } = {}) => {
    if (loading) {
      configureStore.dispatch(setLoading(true))
    }
    try {
      let headers = {
        Accept: "application/json",
        ...header,
      }
      if (token) {
        headers.Authorization = `Bearer ${localStorage.getItem(TOKEN_ID)}`
      }

      // console.log(777,API_URL_WEB + url)

      const result = await axios({
        method: method,
        url: API_URL_WEB + url,
        // http://localhost:8000/app/equip/undefined/product/equipControl/switch/mod
        data: body,
        headers,
        responseType: options.responseType,
      })
      debug(result)
      return result
    } catch (err) {
      if (err.response) {
        debug(err.response)
        if (err.response.status === 400) {
          configureStore.dispatch(setServerErrorPopup({ open: true, text: err.response.data.message }))
          return err.response
        } else if (err.response.status === 401) {
          localStorage.removeItem(TOKEN_ID)
          navigate("/app/login")
          return err.response
        } else if (err.response.status === 403) {
          localStorage.removeItem(TOKEN_ID)
          navigate("/app/login")
          return err.response
        } else if (err.response.status === 500) {
          configureStore.dispatch(setServerErrorPopup({ open: true, text: err.response.data.message }))
          return err.response
        }
      }
    } finally {
      if (loading) {
        configureStore.dispatch(setLoading(false))
      }
    }
  }
}

const api = {
  post: apiFunction("POST"),
  get: apiFunction("GET"),
  delete: apiFunction("DELETE"),
  patch: apiFunction("PATCH"),

  post_WEB: apiFunction_WEB("POST"),
  get_WEB: apiFunction_WEB("GET"),
  delete_WEB: apiFunction_WEB("DELETE"),
  patch_WEB: apiFunction_WEB("PATCH"),
}

export default api
